module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-greyville-white.a6f47934.svg";